'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RadioGroup = require('@cimpress/react-components/lib/RadioGroup');

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _Radio = require('@cimpress/react-components/lib/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _tetheredSelect = require('./tetheredSelect');

var _tetheredSelect2 = _interopRequireDefault(_tetheredSelect);

var _reactVirtualizedSelect = require('react-virtualized-select');

var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManyTenantsSelect = function ManyTenantsSelect(_ref) {
  var onSelectType = _ref.onSelectType,
      onSelectTenant = _ref.onSelectTenant,
      resourceType = _ref.resourceType,
      selectedTenant = _ref.selectedTenant,
      merchants = _ref.merchants,
      fulfillers = _ref.fulfillers;
  return _react2.default.createElement(
    'div',
    null,
    merchants.length && fulfillers.length ? _react2.default.createElement(
      _RadioGroup2.default,
      { inline: true, name: 'Tenant type', onChange: onSelectType, defaultSelected: resourceType },
      _react2.default.createElement(_Radio2.default, { value: 'merchant', label: 'Merchants' }),
      _react2.default.createElement(_Radio2.default, { value: 'fulfiller', label: 'Fulfillers' })
    ) : _react2.default.createElement(
      'h3',
      null,
      resourceType === 'merchant' ? 'Merchants' : 'Fulfillers'
    ),
    _react2.default.createElement(_reactVirtualizedSelect2.default, {
      selectComponent: _tetheredSelect2.default,
      value: selectedTenant,
      onChange: onSelectTenant,
      options: resourceType === 'merchant' ? merchants : fulfillers
    })
  );
};

ManyTenantsSelect.propTypes = {
  onSelectTenant: _propTypes2.default.func.isRequired,
  onSelectType: _propTypes2.default.func.isRequired,
  resourceType: _propTypes2.default.string.isRequired,
  selectedTenant: _propTypes2.default.string,
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired
};

ManyTenantsSelect.defaultProps = {
  selectedTenant: undefined
};

exports.default = ManyTenantsSelect;
//# sourceMappingURL=ManyTenantsSelect.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/components/tenant/ManyTenantsSelect.js
// module id = 518
// module chunks = 0